module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isResearchGroup && !_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("课题组管理")])]), _vm._v(" "), (_vm.hasLogin && _vm.displayChosenResearchGroup && _vm.displayChosenResearchGroup.researchGroupName) ? _c('div', {
    staticClass: "box_2"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('object', {
    staticClass: "blue-layer",
    attrs: {
      "data": '/static/img/svg/首页蓝色背景.svg',
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avator",
    attrs: {
      "src": "/static/img/avator.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "luWei"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [(_vm.displayChosenResearchGroup.leaderNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("课题组组长")])]) : _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("课题组成员")])]), _vm._v(" "), (_vm.displayChosenResearchGroup.approverNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("审批人")])]) : _vm._e(), _vm._v(" "), (_vm.displayChosenResearchGroup.accountCustomerNo === _vm.customerNo) ? _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("对账人")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "outer2"
  }, [(_vm.displayChosenResearchGroup.approveType === _vm.approveTypeNone) ? _c('div', {
    staticClass: "tagWrap_none"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.displayChosenResearchGroup.approveType]))])]) : (_vm.displayChosenResearchGroup.approveType === _vm.approveTypeThreshold) ? _c('div', [(_vm.displayChosenResearchGroup.approveThreshold) ? _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("单笔订单限额￥" + _vm._s(_vm.displayChosenResearchGroup.approveThreshold))])]) : _vm._e(), _vm._v(" "), (_vm.displayChosenResearchGroup.monthlyLimit) ? _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("单月累积限额￥" + _vm._s(_vm.displayChosenResearchGroup.monthlyLimit))])]) : _vm._e()]) : _c('div', {
    staticClass: "tagWrap_threshold"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.researchGroupApproveTypeDictionary[_vm.displayChosenResearchGroup.approveType]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "group_detail"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName))]), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupNo))])]), _vm._v(" "), _c('div', {
    staticClass: "block_2",
    on: {
      "click": _vm.toggleShowChooseBox
    }
  }, [_c('svg', {
    staticClass: "icon iconzhuanrang",
    attrs: {
      "width": "4vw",
      "height": "4vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M99.119848 428.002088h828.014506a43.350032 43.350032 0 0 0 43.350032-43.350031 43.248882 43.248882 0 0 0-16.451337-33.957525 43.465632 43.465632 0 0 0-9.219107-8.756707L635.50424 124.869766a43.350032 43.350032 0 1 0-49.809186 70.964002l207.270952 145.461032H99.119848a43.350032 43.350032 0 0 0 0 86.707288zM927.134354 601.07709H99.119848a43.350032 43.350032 0 0 0-43.350032 43.350032 43.205532 43.205532 0 0 0 16.451337 33.9503c2.564877 3.272927 5.635504 6.242405 9.219107 8.756706l309.309701 217.075284a43.313907 43.313907 0 0 0 60.386594-10.584632 43.350032 43.350032 0 0 0-10.577407-60.386595L233.288196 687.777154h693.846158a43.350032 43.350032 0 0 0 0-86.700064z",
      "fill": "#929292"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "switchingResearchGroup"
  }, [_vm._v("切换课题组")])])]), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.firstLevelEnterpriseName))]), _vm._v(" "), _c('div', {
    staticClass: "group_2"
  }, [_c('span', {
    staticClass: "character"
  }, [_vm._v("组长："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.leaderName))])]), _vm._v(" "), _c('span', {
    staticClass: "character"
  }, [_vm._v("审批人："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.approverName))])]), _vm._v(" "), _c('span', {
    staticClass: "character"
  }, [_vm._v("对账人："), _c('span', {
    staticClass: "character-name"
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.accountCustomerName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [(_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "info_8",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("课题组订单")]), _vm._v(" "), _c('div', {
    staticClass: "block_7",
    on: {
      "click": function($event) {
        return _vm.toOrder(1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14px",
      "height": "15px",
      "viewBox": "0 0 14 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("订单备份 2")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-247.000000, -426.000000)",
      "fill": "#979797",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-3#group#",
      "transform": "translate(236.000000, 419.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "订单备份-2",
      "transform": "translate(11.000000, 7.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.27230273,15 L2.27230273,15 C1.01805605,14.9984262 0.00171999101,14.0668211 0,12.9171431 L0,2.08285318 L0,2.08291935 C0.00167718208,0.933241334 1.01798443,0.00160772079 2.27223452,0 L11.7276972,0 L11.7276973,0 C12.981944,0.00157386508 13.99828,0.933178898 14,2.08285691 L14,12.9157108 L14,12.9156447 C13.9983228,14.0653227 12.9820156,14.9969563 11.7277655,14.998564 L2.27230273,15 Z M2.27230273,0.917146346 L2.27230279,0.917146346 C1.56943517,0.917933451 0.999860992,1.44002085 0.999002708,2.0842892 L0.999002708,12.9171431 L0.999002708,12.9171131 C0.99984338,13.5613814 1.56940107,14.0834817 2.27227039,14.0842856 L11.7277331,14.0842856 L11.7277331,14.0842856 C12.4306007,14.0834985 13.0001748,13.5614111 13.0010659,12.9171427 L13.0010659,2.08285282 L13.0010659,2.08288286 C13.0002252,1.43861451 12.4306675,0.916514206 11.7277982,0.915710346 L2.27230273,0.917146346 Z",
      "id": "形状"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.59076309,6.9356706 L3.59076312,6.9356706 C3.30111122,6.94909507 3.05318119,6.76522655 3.03699665,6.52498819 C3.02081095,6.28474983 3.24249855,6.07911575 3.53215045,6.06569222 C3.55167311,6.06478741 3.57124135,6.06478741 3.59076401,6.06569222 L11.4454007,6.06569222 L11.4454007,6.06569222 C11.7350526,6.05226776 11.9829826,6.23613627 11.9991672,6.47637463 C12.0153529,6.71661299 11.7936653,6.92224708 11.5040134,6.9356706 C11.4844907,6.93657541 11.4649225,6.93657541 11.4453998,6.9356706 L3.59076309,6.9356706 Z M3.59076309,8.99321262 L3.59076313,8.99321262 C3.30291885,9.02318376 3.04028113,8.8539443 3.0041466,8.61520519 C2.96801083,8.37646607 3.17206038,8.15863337 3.45990466,8.12866326 C3.50335388,8.12413918 3.5473148,8.12413918 3.59076402,8.12866325 L8.94991953,8.12866325 L8.9499195,8.12866325 C9.24002196,8.12866324 9.47519852,8.32371808 9.47519852,8.56433163 C9.47519852,8.80494369 9.24002375,9 8.9499195,9 L3.59076309,8.99321262 Z M3.59076309,4.87133675 L3.59076307,4.87133675 C3.30066061,4.87133675 3.06548405,4.67628192 3.06548405,4.43566837 C3.06548405,4.19505631 3.30065882,4 3.59076307,4 L11.4453998,4 L11.4453998,4 C11.7355022,4 11.9706788,4.19505483 11.9706788,4.43566837 C11.9706788,4.67628043 11.735504,4.87133675 11.4453998,4.87133675 L3.59076309,4.87133675 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('span', {
    staticClass: "text_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("全部订单")])])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "block_8"
  }, [_c('div', {
    staticClass: "group_7",
    on: {
      "click": function($event) {
        return _vm.toOrder(2)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "35px",
      "height": "31px",
      "viewBox": "0 0 35 31",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("daifukuan备份 2#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-63.000000, -472.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "daifukuan备份-2#merge#",
      "transform": "translate(63.000000, 472.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.84192864,7.27272727 L28.0786574,6.28335089 L30.5319149,6.28335089 L28.5596029,2.16652355 C27.8814262,0.508238737 25.9899977,-0.364382716 24.1782083,0.14459579 L3.72340426,6.28335089 L5.84192864,7.27272727 L5.84192864,7.27272727 Z",
      "id": "路径",
      "fill": "#333333"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.853125,5.54545455 C32.695625,5.54545455 35,7.7369697 35,10.4406061 L35,14.029697 L27.75375,14.030303 C25.36375,14.030303 23.408125,15.8375758 23.335625,18.0878788 L23.333125,18.2345455 C23.333125,20.5072727 25.233125,22.3672727 27.6,22.4357576 L27.75375,22.4381818 L35,22.4381818 L35,26.1048485 C35,28.8078788 32.695625,31 29.853125,31 L5.146875,31 C2.304375,31 0,28.8084848 0,26.1048485 L0,10.4406061 C0,7.73757576 2.304375,5.54545455 5.146875,5.54545455 L29.853125,5.54545455 Z",
      "id": "路径",
      "fill": "#5878FA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.5744681,18.2727273 C24.5744681,19.678543 25.7413855,20.8181818 27.1808511,20.8181818 C28.6203166,20.8181818 29.787234,19.678543 29.787234,18.2727273 C29.787234,16.8669115 28.6203166,15.7272727 27.1808511,15.7272727 C25.7413855,15.7272727 24.5744681,16.8669115 24.5744681,18.2727273 Z",
      "id": "路径",
      "fill": "#333333"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "txt_7",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("待审批")])]), _vm._v(" "), (_vm.orderList.waitApprovedOrderList && _vm.orderList.waitApprovedOrderList.length > 0) ? _c('div', {
    staticClass: "colorDiv_4"
  }, [_vm._v("\n            " + _vm._s(_vm.orderList.waitApprovedOrderList.length) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_51",
    on: {
      "click": function($event) {
        return _vm.toOrder(3)
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "word_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("执行中")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_4",
    on: {
      "click": function($event) {
        return _vm.toOrder(4)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "33px",
      "height": "32px",
      "viewBox": "0 0 33 32",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("yiwancheng备份 2#merge#")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "主界面",
      "transform": "translate(-280.000000, -471.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "yiwancheng备份-2#merge#",
      "transform": "translate(280.000000, 471.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.51392857,1.44680851 L8.71435714,1.44680851 C9.293625,1.44680851 9.73676786,1.98033362 9.68078571,2.58009362 L9.64601786,2.81708085 C9.63423214,2.9124834 9.62833929,3.00424 9.62775,3.09052766 C9.62775,4.16608511 10.3378393,5.12314894 11.0143393,5.12314894 L21.75525,5.12314894 C22.3710536,5.12314894 23.0746607,4.15575489 23.0740714,3.09052766 C23.0740714,3.00241702 23.0681786,2.91126809 23.0563929,2.81647319 L23.0222143,2.58009362 C22.9662321,1.98033362 23.409375,1.44680851 23.9886429,1.44680851 L28.1466429,1.44680851 C31.2109286,1.44680851 33,3.51832 33,6.70002553 L33,26.6221447 C33,30.1392783 31.2816429,31.8297872 27.9321429,31.8297872 L4.72783929,31.8297872 C1.53685714,31.8297872 0,29.997086 0,26.6209294 L0,6.70002553 C0,3.3153617 1.332375,1.44680851 4.51392857,1.44680851 Z",
      "id": "路径",
      "fill": "#5878FA"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.226081,0 C11.2844749,0 10.5319149,0.807801418 10.5319149,1.80609929 C10.5319149,2.80680851 11.2862869,3.61702128 12.226081,3.61702128 L20.1176939,3.61702128 C21.0115854,3.61702128 21.7659574,2.80680851 21.7659574,1.80609929 C21.7659574,0.807801418 21.0133974,0 20.0699794,0 L12.226081,0 Z",
      "id": "路径",
      "fill": "#333333"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.6094306,22.4255319 C15.2653615,22.4257077 14.9354445,22.2902224 14.6928646,22.0491303 L9.50701454,16.9049774 C9.00120792,16.4014043 9.00120792,15.5889796 9.50701454,15.0854065 C9.74964249,14.8443648 10.0795137,14.7088382 10.4235806,14.7088382 C10.7676475,14.7088382 11.0975187,14.8443648 11.3401466,15.0854065 L15.6094306,19.3209632 L23.7664471,11.2286297 C24.0087567,10.9869985 24.3387472,10.8510638 24.6830132,10.8510638 C25.0272792,10.8510638 25.3572696,10.9869985 25.5995792,11.2286297 C26.1051048,11.7304983 26.1051048,12.5439535 25.5995792,13.0464167 L16.5259967,22.0491303 C16.2832654,22.2899995 15.9534466,22.4255319 15.6094306,22.4255319 L15.6094306,22.4255319 Z",
      "id": "路径",
      "fill": "#FFFFFF"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "text_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("已完成")])])]), _vm._v(" "), (_vm.orderList.waitApprovedOrderList && _vm.orderList.waitApprovedOrderList.length > 0) ? _c('div', {
    staticClass: "group_8"
  }, [_c('svg', {
    staticClass: "anonymousIconfont",
    attrs: {
      "width": "200px",
      "height": "200.00px",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 4.12672c280.49408 0 507.87328 227.3792 507.87328 507.87328 0 280.49408-227.3792 507.87328-507.87328 507.87328C231.50592 1019.87328 4.12672 792.49408 4.12672 512 4.12672 231.50592 231.50592 4.12672 512 4.12672zM512 685.96736c-42.47552 0-76.91264 34.42688-76.91264 76.91264 0 42.47552 34.43712 76.91264 76.91264 76.91264 42.47552 0 76.91264-34.43712 76.91264-76.91264C588.91264 720.39424 554.47552 685.96736 512 685.96736zM509.78816 625.83808c36.58752 0 66.24256-29.66528 66.24256-66.24256l0-309.1456c0-36.58752-29.65504-66.24256-66.24256-66.24256-36.58752 0-66.24256 29.66528-66.24256 66.24256l0 309.1456C443.5456 596.18304 473.20064 625.83808 509.78816 625.83808z",
      "fill": "#FE654D"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "desc",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("您有" + _vm._s(_vm.orderList.waitApprovedOrderList.length) + "个订单需要审批，请尽快审批")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberManagement'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1040 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M401.1 312.7m-193.8 0a193.8 193.8 0 1 0 387.6 0 193.8 193.8 0 1 0-387.6 0Z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M738.9 833.2c0 169.3-675.5 169.3-675.5 0S214.6 562 401.1 562s337.8 101.9 337.8 271.2zM644.7 63.5c-47.2 0-90.4 16.9-124 44.9 75.3 36.5 127.4 113.5 127.4 202.9 0 50.8-17 97.5-45.3 135.2 13.5 3 27.4 4.6 41.8 4.6 107 0 193.8-86.8 193.8-193.8S751.8 63.5 644.7 63.5z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M622.6 513.2c-20.4 0-83.1 6.1-104.2 16.1 131.8 26.8 275.1 129.3 275.1 293.1 0 25.6-10.4 48.2-28.7 67.9 110.1-18 195.5-58.2 195.5-120.6 0.1-175.4-151.2-256.5-337.7-256.5z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("成员管理")]), _vm._v(" "), (_vm.approvalMemberListLength > 0) ? _c('div', {
    staticClass: "colorDiv_Member"
  }, [_vm._v("\n              " + _vm._s(_vm.approvalMemberListLength) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'accountCustomer'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M219.232 287.872l571.84-26.032h63.088l-50.72-108.32c-17.44-43.632-66.08-66.592-112.672-53.2L164.752 261.84l54.48 26.032z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M828.24 256C901.008 256 960 313.856 960 385.232v94.752L774.496 480c-61.184 0-111.248 47.712-113.104 107.12l-0.064 3.872c0 60 48.64 109.104 109.232 110.912l3.936 0.064H960v96.8C960 870.128 901.008 928 828.24 928H195.76C122.992 928 64 870.144 64 798.768V385.232C64 313.872 122.992 256 195.76 256h632.48z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M768 592m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置对账人")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'approver'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置审批人")])]), _vm._v(" "), _c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchMemberCharacterSetting',
        query: {
          character: 'horMember'
        }
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M645.488 544c3.552 9.776 5.328 20.032 5.28 30.352v96.208c0.064 25.568-10.848 50.112-30.32 68.208-19.488 18.096-45.952 28.272-73.552 28.272h-70.976c-27.584 0-54.048-10.176-73.536-28.272-19.488-18.096-30.4-42.64-30.304-68.208v-96.208c-0.016-10.288 1.664-20.528 4.96-30.352C222 582.48 96 679.52 96 791.168v72.352c0.16 53.12 46.512 96.176 103.84 96.48h624.32c57.328-0.304 103.68-43.36 103.84-96.48v-72.352c0-112.48-126-208.688-281.344-247.168h-1.168z m-134-32C635.488 512 736 411.632 736 288.112 736 164.592 636.496 64 512.512 64 388.512 64 288 164.368 288 288.112S389.008 512 512.512 512h-1.024z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M512 544c-26.512 0-48 23.92-48 53.44v53.12c0 29.52 21.488 53.44 48 53.44s48-23.92 48-53.44v-53.12c0.016-14.192-5.024-27.792-14.016-37.824-8.8-9.648-20.56-15.232-32.912-15.616H512z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("设置科研者之家会员")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]) : (_vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_51"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M634.08 64H389.872C359.936 64 336 87.008 336 115.456c0 28.496 24 51.568 53.888 51.568h245.696C664 167.04 688 143.952 688 115.456 688 87.008 664.048 64 634.08 64z",
      "fill": "#333333"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.464 98.336a117.6 117.6 0 0 0-1.536 17.968c0 45.472 27.936 90.208 62.832 90.208h302.32c33.168 0 61.056-44.736 61.024-90.208 0-6.064-0.544-12.048-1.488-17.968h96.896C894.56 98.336 928 149.184 928 222.512v614.528c0 88.272-35.728 122.832-109.232 122.832H196.176C122.672 959.872 96 915.792 96 836.992V222.528c0-73.328 18.624-124.16 94.448-124.16z m391.536 624h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z m0-192h-368a40 40 0 1 0 0 80h368a40 40 0 1 0 0-80z",
      "fill": "#5878FA"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]) : _c('div', {
    staticClass: "management"
  }, [_c('span', {
    staticClass: "managementTools"
  }, [_vm._v("管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "container_5"
  }, [_c('router-link', {
    staticClass: "outer_3",
    attrs: {
      "to": {
        name: 'ResearchGroupDetail'
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "15vw",
      "height": "15vw",
      "viewBox": "0 0 1040 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M350.88 484.528h-108.192c-76.704 0-139.648-62.784-139.648-139.328v-109.872C103.04 158.8 165.984 96 242.688 96h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92c1.952 78.496-60.976 141.28-139.664 141.28z m444.512 0H687.2c-76.72 0-139.648-62.784-139.648-139.328v-109.872C547.568 158.8 610.496 96 687.2 96h108.16c76.72 0 139.664 62.8 139.664 139.328v107.92c0 78.496-62.944 141.28-139.648 141.28zM350.864 928h-108.16c-76.72 0-139.664-62.784-139.664-139.312v-107.92c0-76.528 62.944-139.328 139.648-139.328h108.176c76.72 0 139.664 62.8 139.664 139.328v107.92C492.48 865.216 429.552 928 350.864 928z",
      "fill": "#5878FA"
    }
  }), _c('path', {
    attrs: {
      "d": "M886.48 634.176H597.568c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h290.944c16.288 0 30.528 13.584 30.528 29.088 0 15.52-16.272 29.088-32.56 29.088z m-48.832 129.952H597.568c-16.288 0-30.528-13.584-30.528-29.104s14.24-29.088 30.528-29.088h240.08c16.288 0 30.528 13.584 30.528 29.088 0 15.52-14.24 29.104-30.528 29.104zM717.6 896h-120.032c-16.288 0-30.528-13.568-30.528-29.088 0-15.52 14.24-29.088 30.528-29.088h120.032c16.288 0 30.528 13.568 30.528 29.088 0 15.52-14.24 29.088-30.528 29.088z",
      "fill": "#333333"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "setUpReconcilingPerson"
  }, [_vm._v("课题组信息")])]), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "outer_3"
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vw",
      "visibility": "hidden"
    }
  }, [_vm._v("hidden")])])]) : _c('div', {
    staticClass: "box_3"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.showChooseResearchGroup) ? _c('ChooseResearchGroup', {
    on: {
      "toggleShow": _vm.toggleShowChooseBox
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "275px"
    },
    attrs: {
      "src": "/static/img/无课题组提示.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remind-info"
  }, [_c('span', {
    staticClass: "remind-title"
  }, [_vm._v("您还未加入G客课题组~")]), _vm._v(" "), _c('div', {
    staticClass: "remind-text"
  }, [_c('span', [_vm._v("为您的科研课题组创建专属账户")]), _vm._v(" "), _c('span', [_vm._v("享受专属科研服务、更优的折扣")]), _vm._v(" "), _c('span', [_vm._v("账户月结、便捷跟踪管理")]), _vm._v(" "), _c('span', [_vm._v("联系业务人员或致电"), _c('a', {
    staticStyle: {
      "color": "#ff9400"
    },
    attrs: {
      "href": "tel:400-621-0302"
    }
  }, [_vm._v("400-621-0302")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29cccd02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/ResearchGroupHome.vue
// module id = 1578
// module chunks = 8